import o, { useState as k, useRef as b, useCallback as C, useEffect as N } from "react";
import H from "classnames";
import { useTranslation as $ } from "react-i18next";
import { tint as j } from "../../../../../common/libs/tint.js";
import { useMapsApi as q } from "../../hooks/useMapsApi.js";
import { useOnClickOutside as J } from "../../../dom/hooks/useOnClickOutside.js";
import i from "./autocomplete.module.scss.js";
const P = 500, O = 3;
function oe({
  apiKey: V,
  design: s,
  texts: l,
  country: R,
  storePrefix: _,
  place: u,
  onPlaceSelected: L,
  coordinates: I
}) {
  const {
    isApiReady: m,
    getPredictions: S,
    geoLocate: z,
    getPlaceDetails: T
  } = q(V), { t: v } = $(), [M, n] = k([]), [r, c] = k(!1), d = b(null), f = b(/* @__PURE__ */ new Map()), [B, E] = k((u == null ? void 0 : u.formattedAddress) ?? ""), A = () => `${_}last-place-v2`, g = C(async (e) => {
    if (m) {
      if (e.length < O) {
        n([]);
        return;
      }
      if (f.current.has(e)) {
        n(f.current.get(e)), r || c(!0);
        return;
      }
      try {
        const t = await S(e, R, I) || [];
        n(t), t.length > 0 && (f.current.set(e, t), r || c(!0));
      } catch {
        n([]);
      }
    }
  }, [m, S, R, I, r, c, n]), G = C((e) => {
    if (E(e), d.current && clearTimeout(d.current), e.length < O) {
      n([]);
      return;
    }
    if (f.current.has(e)) {
      n(f.current.get(e)), r || c(!0);
      return;
    }
    [...f.current.keys()].some((t) => t.startsWith(e)) || (d.current = setTimeout(() => {
      g(e);
    }, P));
  }, [g, r, c, n, E]), K = C((e) => {
    r || c(!0), e.length >= O ? g(e) : e.length > 0 && n([]);
  }, [g, r, c, n]);
  N(() => () => {
    d.current && clearTimeout(d.current);
  }, []);
  const y = (e) => {
    var a, t, h, F;
    return {
      placeId: e.place_id ?? "",
      lat: (t = (a = e.geometry) == null ? void 0 : a.location) == null ? void 0 : t.lat(),
      long: (F = (h = e.geometry) == null ? void 0 : h.location) == null ? void 0 : F.lng(),
      formattedAddress: e.formatted_address ?? "",
      addressComponents: e.address_components ?? []
    };
  }, p = (e, a, t) => {
    c(!1), E(e.formattedAddress), a && _ !== void 0 && localStorage.setItem(A(), e.placeId), t && typeof L == "function" && L(e);
  }, U = async () => {
    navigator.geolocation.getCurrentPosition(async (e) => {
      const {
        coords: {
          latitude: a,
          longitude: t
        }
      } = e, [h] = await z(a, t);
      p(
        y(h),
        !0,
        !0
      );
    });
  }, W = async (e) => {
    p(
      y(await T(e.place_id)),
      !0,
      !0
    );
  }, D = b(null), Y = C(() => {
    c(!1);
  }, []);
  return J(D, Y), N(() => {
    if (!m || _ === void 0 || u !== void 0) return;
    const e = localStorage.getItem(A());
    e && T(e).then((a) => {
      p(
        y(a),
        !1,
        !0
      );
    });
  }, [m]), N(() => {
    u !== void 0 && p(u, !0, !1);
  }, [u]), /* @__PURE__ */ o.createElement(
    "div",
    {
      "data-testid": "autocomplete",
      className: i.autocomplete,
      style: {
        "--text-color": s.textColor,
        "--label-color": s.labelColor ?? s.textColor,
        "--background-color": s.backgroundColor,
        "--l-background-color": j(0.01, s.backgroundColor)
      },
      ref: D
    },
    !m && /* @__PURE__ */ o.createElement("div", { style: { color: s.textColor } }, "loading"),
    m && /* @__PURE__ */ o.createElement("div", null, /* @__PURE__ */ o.createElement(
      "label",
      {
        className: H({
          [i.searchLabel]: !0,
          [i.searchLabel__active]: r
        })
      },
      /* @__PURE__ */ o.createElement("div", { className: i.searchLabel__text }, (l == null ? void 0 : l.label) || v("autocomplete.label")),
      /* @__PURE__ */ o.createElement(
        "input",
        {
          spellCheck: "false",
          autoComplete: "off",
          className: i.input,
          name: "search--autocomplete",
          placeholder: (l == null ? void 0 : l.placeholder) || v("autocomplete.placeholder") || "",
          value: B,
          onClick: () => {
            r || c(!0);
          },
          onChange: (e) => G(e.target.value),
          onFocus: (e) => K(e.target.value),
          type: "text",
          "data-testid": "ordering-address-input"
        }
      )
    ), r && /* @__PURE__ */ o.createElement(
      "div",
      {
        className: H({
          [i.menu]: !0,
          [i.menu__top]: s.menuOnTop
        })
      },
      (navigator == null ? void 0 : navigator.geolocation) && /* @__PURE__ */ o.createElement("div", { className: i.geolocation, onClick: () => U() }, /* @__PURE__ */ o.createElement("i", { className: "lni lni-map-marker" }), " ", /* @__PURE__ */ o.createElement("span", null, (l == null ? void 0 : l.geolocation) || v("autocomplete.geolocation"))),
      M.length > 0 && /* @__PURE__ */ o.createElement("ul", { className: i.predictionList, "data-testid": "ordering-address-predictions" }, M.map((e) => /* @__PURE__ */ o.createElement(
        "li",
        {
          onClick: () => W(e),
          key: e.place_id
        },
        e.structured_formatting.main_text,
        ",  ",
        e.structured_formatting.secondary_text
      )))
    ))
  );
}
export {
  oe as Autocomplete
};
//# sourceMappingURL=Autocomplete.js.map
